export default "__VITE_ASSET__BHlOLqEs__"